<template>
    <div class="row">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'QwixxRow',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.row {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
}

</style>
